export default __webpack_public_path__ + "static/media/p17.c1cb6bfa.jpeg";